export default [
  {
    path: '/:locale([en/]*)?/policy/:id(\\d+)?',
    name: 'Policy',
    component: () => import('@/views/policy/Index'),
    meta: {
      language: false,
      sitemap: {
        loc: '/policy'
      }
    }
  }
]
